import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';


const httpOptionsFormData = {
  headers: new HttpHeaders({
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

@Injectable({providedIn: 'root'})

export class PaymentService {

  public applicationFeeType = "ApplicationFee";
  public licenseFeeType = "LicenseFee";
  public reducedLicenseFeeType = "ReducedLicenseFee";
  public CivilPenaltyFeeType = "CivilPenaltyFeeType"
  public FirmEntityType = "FirmApplication";
  public PaymentIssuedCommentSearchText = "Online Payment issued";  
  public paymentAwaitingClearanceStatus = 'Awaiting Clearance';
  public paymentVoidedStatus = 'Voided';

    public paymentOptions = [
    {
      Text: "Firm (LBPA)",
      Value: "FirmApplication-firm-lbpa",
      LicenseFee: "255.00",
      ReducedLicenseFee: "250.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Firm (RRP)",
      Value: "FirmApplication-firm-rrp",
      LicenseFee: "250.00",
      ReducedLicenseFee: "250.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Firm Worker",
      Value: "FirmApplication-firm-worker",
      LicenseFee: "150.00",
      ReducedLicenseFee: "150.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the worker license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Firm Supervisor",
      Value: "FirmApplication-firm-supervisor",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the Supervisor license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Firm Risk Assessor",
      Value: "FirmApplication-firm-risk-assessor",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the Risk Assessor license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Firm Project Designer",
      Value: "FirmApplication-firm-project-designer",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the Project Designer license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Firm Inspector",
      Value: "FirmApplication-firm-inspector",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Firm License application has been submitted, you will receive a request to pay the Inspector license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Supervisor (LBPA)",
      Value: "PersonApplication-Supervisor",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Individual License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Risk Assessor (LBPA)",
      Value: "PersonApplication-Risk Assessor",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Individual License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Project Designer (LBPA)",
      Value: "PersonApplication-Project Designer",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Individual License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Inspector (LBPA)",
      Value: "PersonApplication-Inspector",
      LicenseFee: "255.00",
      ReducedLicenseFee: "255.00",
      ApplicationFeeNotice: "After the Individual License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "Worker (LBPA)",
      Value: "PersonApplication-Worker",
      LicenseFee: "150.00",
      ReducedLicenseFee: "150.00",
      ApplicationFeeNotice: "After the Individual License application has been submitted, you will receive a request to pay the license fee. A \"Pay Fee\" button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "LBPA Inspector (Initial-Accred)",
      Value: "AtpAccreditation-atp-inspector-initial-accred-lbpa",
      LicenseFee: "0.00",
      ReducedLicenseFee: "0.00",
      ApplicationFeeNotice: "ATP Accreditation application fee information.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "RRP Course Student Fee",
      Value: "AtpCourse-atp-student-multiple-rrp",
      LicenseFee: "0.00",
      ReducedLicenseFee: "0.00",
      ApplicationFeeNotice: "ATP Course student fee information.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "ATP Application (LBPA)",
      Value: "AtpApplication-atp-lbpa",
      LicenseFee: "0.00",
      ReducedLicenseFee: "0.00",
      ApplicationFeeNotice: "The accreditation fee is the total of the course fees selected on the application.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    },
    {
      Text: "ATP Application (RRP)",
      Value: "AtpApplication-atp-rrp",
      LicenseFee: "0.00",
      ReducedLicenseFee: "0.00",
      ApplicationFeeNotice: "The accreditation fee is the total of the course fees selected on the application.",
      LicenseFeeNotice: "",
      CivilPenaltyNotice: ""
    }
  ]

  public paymentPendingStatus = 'Pending';
  public paymentApprovedAwaitingPayment = 'Approved, Pending Payment and Clearance'
  public paymentPaidStatus = 'Paid'
  public paymentClearedStatus = 'Cleared';
  public paymentStatuses = [this.paymentPendingStatus, this.paymentClearedStatus, this.paymentPaidStatus ];
  public paymentMethods = [
    'Online',
    'Money Order',
    'Personal/Business Check',
    'Cashier\'s Check',
    'Cash'];
  private api: string = environment.privateApi + 'Payments/';

  constructor(private http: HttpClient) { }

  public getPaymentTypeName(entityType: string): string {
    let option = this.paymentOptions.find(po => po.Value == entityType);
    if(option != null && option != undefined) {
      return option.Text;
    }
    return entityType;
  }

  public getPaymentTypeNotice(entityType: string, feeType: string): string {
    let option = this.paymentOptions.find(po => po.Value == entityType);
    if(option != null && option != undefined) {
      if(feeType == this.licenseFeeType  ) {
        return option.LicenseFeeNotice;
      }
      if(feeType == this.applicationFeeType) {
        return option.ApplicationFeeNotice;
      }
      if(feeType == this.CivilPenaltyFeeType) {
        return option.CivilPenaltyNotice;
      }

      return "";

    }
    return "";
  }

  public getPaymentTypeAmount(entityType: string, feeType: string): string {
    let value = entityType;
    if(feeType != null && feeType.length > 0) {
      value = entityType + '-' + feeType;
    }
    let option = this.paymentOptions.find(po => po.Value == value);
    if(option != null && option != undefined) {
        return option.LicenseFee;
    }
    return "";
  }

  public getPaymentTypeDescription(entityType: string, feeType: string): string {
    let value = entityType;
    if(feeType != null && feeType.length > 0) {
      value = entityType + '-' + feeType;
    }
    let option = this.paymentOptions.find(po => po.Value == value);
    if(option != null && option != undefined) {
      return option.Text
    }
    return "";
  }

  public negotiateToken(paymentId: number) : Observable<string> {
    return this.http.post<string>(this.api + 'NegotiateToken/' + paymentId, httpOptionsFormData);
  }

  public updatePaymentSuccess(token: string) : Observable<string> {
    return this.http.post<string>(this.api + 'UpdatePaymentSuccess/' + token, httpOptionsFormData);
  }

}

